import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ClientProvidedServices } from 'src/app/api/client-api/models';
import { ProvidedService } from 'src/app/api/provided-services-api/models';
import { ProvidedServicesService } from 'src/app/api/provided-services-api/services';
import { ProvidedServicesGlobalService } from '../provided-services-global/provided-services-global.service';

@Injectable({
	providedIn: 'root'
})
export class CustomerRestrictionService {
	private globalProvidedServicesService = inject(
		ProvidedServicesGlobalService
	);
	private providedServicesService = inject(ProvidedServicesService);

	private availableServices: Array<ProvidedService> = [];
	public providedServices: Array<ProvidedService> = [];

	public init() {
		this.globalProvidedServicesService.globalProvidedServices$.subscribe(
			(services) => {
				this.providedServices = services;
			}
		);
	}

	public async loadFilteredServices(
		customerId: string,
		operationId: string,
		clientProvidedServices: ClientProvidedServices[]
	): Promise<ProvidedService[]> {
		this.availableServices = await lastValueFrom(
			this.providedServicesService.getProvidedservicesFilterclientV2$Json(
				{
					clientId: customerId,
					isDeleted: false,
					operationId: operationId
				}
			)
		);

		clientProvidedServices?.forEach((e) => {
			if (e?.chat) {
				this.availableServices.push(e.providedService);
			}
		});

		this.availableServices = this.availableServices.filter(
			(value, index, self) =>
				index === self.findIndex((t) => t?.id === value?.id)
		);

		this.availableServices = this.availableServices.filter(
			(service) => service != null && service != undefined
		);
		return this.availableServices;
	}
}
